/**
 * Quill 1.x's default `formats/image` blot sanitizes `src` against an
 * http/https/data allow-list (`node_modules/quill/formats/image.js`), so an
 * `<img>` inserted with a `blob:` object-URL — what our deferred image flow
 * inserts, via the paste/drop matcher (`matchers/imageMatcher.ts`) and
 * `index.tsx`'s `handleAddImage` (`insertEmbed(..., "image", blobUrl)`) —
 * gets silently rewritten to `//:0` at insert time. The `blob:` src then
 * never exists in the document, so `uploadRichTextImages` finds nothing to
 * upload at submit, and the task saves with a permanently broken image.
 *
 * Wraps an existing `sanitize` implementation (Quill's registered
 * `formats/image` blot's static `sanitize`, in `index.tsx`) so `blob:` URLs
 * pass through untouched, while every other URL keeps EXACTLY the wrapped
 * implementation's behavior — http/https/data still allowed, everything
 * else (e.g. `javascript:`) still rejected to `//:0`.
 */
export const allowBlobUrls = (sanitize: (url: string) => string) => (
  url: string
): string => (url?.startsWith("blob:") ? url : sanitize(url));
